module.exports = __webpack_public_path__ + "3c300773d4144b13de022085830f330f.MP3";